import React, { useState } from 'react'
import Window from '../../../assets/icon/classtool-window.svg'
import Artboard from '../../../assets/icon/classtool-artboard.svg'
import Candlestick from '../../../assets/icon/classtool-candlestick.svg'
import Codebox from '../../../assets/icon/classtool-codebox.svg'
import Brush from '../../../assets/icon/classtool-brush.svg'
import Pdf from '../../../assets/icon/classtool-pdf.svg'
import { ReactComponent as Mic } from '../../../assets/icon/classoptions-mic.svg'
import { ReactComponent as MicUnmute } from '../../../assets/icon/classoptions-micunmute.svg'
import { ReactComponent as Video } from '../../../assets/icon/classoptions-video.svg'
import { ReactComponent as Emoji } from '../../../assets/icon/classoptions-emoji.svg'
import { ReactComponent as Chat } from '../../../assets/icon/classoptions-chat.svg'
import { ReactComponent as Recording } from '../../../assets/icon/classoptions-recording.svg'
import { ReactComponent as Pause } from '../../../assets/icon/classoptions-pause.svg'
import { ReactComponent as Stop } from '../../../assets/icon/classoptions-stop.svg'
import { hangB } from 'utils/webrtc/peerConnection'

const ClassFooter = ({ pc, localStream, remoteVideo, localVideo, socket }) => {
  const [mute, setMute] = useState(false)
  const [video, setVideo] = useState(true)

  const muteAudio = () => {}

  return (
    <div className="w-full flex md:flex-row flex-col  justify-between items-center ">
      <div className="flex p-1 bg-[#FEEBDD] rounded-md my-2">
        <div className="m-2 cursor-pointer">
          <img src={Window} alt="" />
        </div>
        <div className="m-2 cursor-pointer">
          <img src={Artboard} alt="" />
        </div>
        <div className="m-2 cursor-pointer">
          <img src={Candlestick} alt="" />
        </div>
        <div className="m-2 cursor-pointer">
          <img src={Codebox} alt="" />
        </div>
        <div className="m-2 cursor-pointer">
          <img src={Brush} alt="" />
        </div>
        <div className="m-2 cursor-pointer">
          <img src={Pdf} alt="" />
        </div>
      </div>
      <div className="flex items-center select-none my-2">
        <div
          className={`w-[55px] h-[48px] m-1 rounded-lg bg-[${
            mute ? '#18181B' : 'white'
          }] flex items-center justify-center bg-opacity-${mute ? '40' : '0'} cursor-pointer`}
          onClick={() => muteAudio(mute, setMute, localVideo)}
        >
          {mute ? <Mic fill="#FDFDFD" /> : <MicUnmute />}
        </div>
        <div
          className={`w-[55px] h-[48px] m-1 rounded-lg bg-[${
            video ? 'white' : '#18181B'
          }] flex items-center justify-center bg-opacity-${video ? '0' : '40'} cursor-pointer`}
          onClick={() => setVideo(!video)}
        >
          {video ? <Video fill="#F79009" /> : <Video fill="#FDFDFD" />}
        </div>
        <div
          className={`w-[55px] h-[48px] m-1 rounded-lg bg-[#18181B] flex items-center justify-center bg-opacity-40 cursor-pointer`}
        >
          <Emoji />
        </div>
        <div
          className={`w-[55px] h-[48px] m-1 rounded-lg bg-[#18181B] flex items-center justify-center bg-opacity-40 cursor-pointer`}
        >
          <Chat />
        </div>
        <div
          className={`px-3 h-[48px] m-1 rounded-lg bg-[#18181B] flex items-center justify-center bg-opacity-40 `}
        >
          <div className="m-1">
            <Recording />
          </div>
          <div className="m-1 text-[#FDFDFD]">Recording in progress ...</div>
          <div className="m-1">
            <Pause />
          </div>
          <div className="m-1">
            <Stop />
          </div>
        </div>
      </div>
      <div
        onClick={() => hangB()}
        className="my-2 w-[200px] h-[44px] flex justify-center items-center rounded-md bg-[#EF4343] text-[#FDFDFD] select-none cursor-pointer"
      >
        End Lesson
      </div>
    </div>
  )
}

export default ClassFooter
